import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import VideoCard from "@/components/video/VideoCard";
import { videos } from "@/mocks/videos";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Home() {
  useDocumentTitle(
    "黄瓜视频App官方网站 - 高清视频播放与下载支持",
    "黄瓜视频App官方网站为您提供丰富的视频资源和便捷的观看体验，涵盖各类热门影视内容与精彩短视频，轻松实现视频播放与下载。",
    "黄瓜视频App,视频播放,影视资源,视频下载,短视频,高清视频",
  );

  const latestVideos = [...videos].sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1));

  return (
    <div className="w-full">
      <HeroCarousel />

      <section className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-sm font-label text-primary-400 tracking-wide">Categories</p>
            <h2 className="mt-1 text-2xl md:text-3xl font-heading font-bold text-foreground-950">按分类探索精彩内容</h2>
          </div>
          <span className="hidden sm:block text-sm text-foreground-500">电影 · 电视剧 · 短视频</span>
        </div>
        <CategoryEntries />
      </section>

      <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-sm font-label text-accent-400 tracking-wide">Latest</p>
            <h2 className="mt-1 text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新上线视频</h2>
            <p className="mt-2 text-sm text-foreground-500">为你精选最近上线的影视与短视频内容，点击卡片查看详情。</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <p className="text-sm font-label text-primary-400 tracking-wide">About</p>
            <h1 className="mt-2 text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              黄瓜视频App —— 高清视频播放与下载支持
            </h1>
            <p className="mt-5 text-sm md:text-base text-foreground-400 leading-relaxed">
              黄瓜视频App官方网站是一站式高清视频资源展示与软件下载平台，面向热爱观看影视剧、短视频并追求高清画质的用户。
              这里汇集热门影视内容与精彩短视频的预览与推荐，帮助你快速了解 App 功能特色、浏览感兴趣的内容，并方便地完成下载安装。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-400 leading-relaxed">
              站内视频封面与简介均为演示信息，播放功能为前端演示效果，不含真实视频流；App 下载链接为示范地址，可在正式上线前替换为真实地址。
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link
                to="/download"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-950 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line w-5 h-5 flex items-center justify-center" />
                前往下载页
              </Link>
              <a
                href="mailto:support@huanggua-video.example.com"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300/70 hover:border-primary-500 text-foreground-800 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center" />
                联系我们
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-5">
            {[
              { icon: "ri-hd-line", value: "1080P+", label: "高清画质" },
              { icon: "ri-download-cloud-2-line", value: "极速下载", label: "下载支持" },
              { icon: "ri-live-line", value: "多端同步", label: "PC / 移动端" },
              { icon: "ri-stack-line", value: "海量资源", label: "影视 + 短视频" },
            ].map((s) => (
              <div
                key={s.label}
                className="p-5 rounded-lg bg-background-100 border border-background-200/60 animate-fade-up"
              >
                <span className="w-11 h-11 rounded-lg bg-accent-500/15 text-accent-400 flex items-center justify-center">
                  <i className={`${s.icon} text-2xl`} />
                </span>
                <p className="mt-4 text-lg font-heading font-bold text-foreground-950">{s.value}</p>
                <p className="mt-1 text-sm text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}